<script>
import { Validator, } from "@/plugins/validator";
import { insuranceMetaFields as metaFields } from "../metaFields";
export default {
    name: "InsuranceForm",

    data() {

        return {
            addInsurance: false,
            patientInsurance: {
                customerID: this.$route.params.patientID,
                organizationID: 0,
                processingModeID:0,
                customerInsuranceId: 0,
                principalOfDependantId: 0,
                patientName: ``,
                patientIDNO: ``,
                active: true,
            },
            insuranceSchemes: [],
            errors: [],
        };
    },

    props: {

        patientInsurancesForUse: Array,
        patientInsurances: Array,
        dependants: Array,
        insurances: Array,
        showModal: Boolean,
        patient: Object,
        processingMode: Array,
       
    },

    watch: {

        'patientInsurance.organizationID' () {
            if(!this.patientInsurance.organizationID) return;

            this.fetchInsuranceSchemes();
        },
         'patientInsurance.processingModeID' () {
            if(!this.patientInsurance.processingModeID) return;

            this.fetchInsurancesForProcessingModes();
        },

        "patientInsurance.principalOfDependantId"() {
            if(!this.patientInsurance.principalOfDependantId) return;

            const dependants = this.dependants.filter(dep => dep.principalOfDependantId == this.patientInsurance.principalOfDependantId);

            if(!dependants.length) return;

            if(dependants[0].principalOfDependant == `Self`) {

                this.patientInsurance.patientName = `${this.patient.firstname} ${this.patient.lastname}`;
                this.patientInsurance.patientIDNO = this.patient.nationalid;
            } else {
                this.patientInsurance.patientName = ``;
                this.patientInsurance.patientIDNO = ``;
            }
        },
    },

    methods: {

        fetchInsuranceSchemes() {
            this.$root.loading = true;
            this.$http.get(`Shared/GetSchemesForOrganization?OrganizationID=${this.patientInsurance.organizationID}`).then(response => {
                this.insuranceSchemes = response.data;
                this.$root.loading = false;
            }).catch(() => {
                this.$root.loading = false;
            });
        },
        fetchInsurancesForProcessingModes() {
            this.$root.loading = true;
            this.$http.get(`MasterData/GetOrganizationsforProcessingMode?processingModeID=${this.patientInsurance.processingModeID}`).then(response => {
                this.insurances = response.data;
                this.$root.loading = false;
            }).catch(() => {
                this.$root.loading = false;
            });
        },

        saveData() {

            (new Validator(this.patientInsurance, metaFields).validate()).then(() => {
                this.$root.loading = true;
                this.$http.post(`PatientRegistration/PatientInsuranceDetails`, this.patientInsurance).then(() => {
                    this.errors = [];
                    this.addInsurance = false;
                    this.$root.loading = false;
                    this.$emit('refresh');
                }).catch(() => { this.$root.loading = false; });
            }).catch(errors => {
                this.errors = errors;
            });
        },

        selectInsuranceForUse(patientInsurance) {
            this.$root.loading = true;
            this.$http.post(`Visits/SelectPatientInsuranceforUse`, patientInsurance).then(() => {
                this.$emit('refreshForUse');
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },

        deselectInsuranceForUse(patientInsurance) {
            this.$root.loading = true;
            this.$http.post(`Visits/DeSelectPatientInsuranceforUse?DetailId=${patientInsurance.customerInsuranceId}&isSelect=${false}`).then(() => {
                this.$emit('refreshForUse');
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="sm:w-11/12 md:w-8/12">
  <template v-slot:title>
    <h5 class="font-bold text-base">Insurance Payment</h5>
  </template>
  <template v-slot:modal-body>
    <div class="flex flex-wrap -m-4">
        <div class="w-full p-tiny text-right -mt-1">
            <button class="btn-sm text-white bg-blue-500 whitespace-no-wrap text-xs rounded" @click.prevent="addInsurance=!addInsurance"><i class="fa fa-plus"></i> Insurance</button>
        </div>
        <div class="flex flex-wrap border-2 border-gray-400 p-tiny" v-if="addInsurance">
            <div class="w-full border-b-2 border-indigo-300 py-1">
                <h5 class="font-bold text-sm">Principal Details: </h5> 
            </div>
            <div class="flex-1 flex flex-wrap">
                <!-- <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-insurance" class="label-control">Processing Mode:</label>
                    <tail-select>
                        <template v-slot:field>
                            <select id="grid-insurance" v-model="patientInsurance.processingModeID" class="input-control input-sm text-xs">
                                <option value="">Select Processing Mode</option>
                                <option v-for="(insurance, idx) in processingMode" :value="insurance.processingModeID" :key="idx">{{ insurance.processingMode }}</option>
                            </select>
                        </template>
                    </tail-select>
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'processingModeID').length">
                        {{ errors.filter(error => error.field == 'processingModeID')[0].message }}</p>
                </div>  -->
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-insurance" class="label-control">Insurance:</label>
                    <tail-select>
                        <template v-slot:field>
                            <select id="grid-insurance" v-model="patientInsurance.organizationID" class="input-control input-sm text-xs">
                                <option value="">Select insurance</option>
                                <option v-for="(insurance, idx) in insurances" :value="insurance.organizationID" :key="idx">{{ insurance.organization }}</option>
                            </select>
                        </template>
                    </tail-select>
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'organizationID').length">
                        {{ errors.filter(error => error.field == 'organizationID')[0].message }}</p>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-scheme" class="label-control">Scheme:</label>
                    <tail-select>
                        <template v-slot:field>
                            <select id="grid-scheme" v-model="patientInsurance.schemeID" class="input-control input-sm text-tiny">
                                <option value="">Select scheme</option>
                                <option v-for="(insuranceScheme, idx) in insuranceSchemes" :key="idx" :value="insuranceScheme.schemeId">{{ insuranceScheme.schemeName }}</option>
                            </select>
                        </template>
                    </tail-select>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-dependant" class="label-control">Dependant:</label>
                    <tail-select>
                        <template v-slot:field>
                            <select id="grid-dependant" v-model="patientInsurance.principalOfDependantId" class="input-control input-sm text-tiny">
                                <option value="">Select dependant</option>
                                <option v-for="(dependant, idx) in dependants" :key="idx" :value="dependant.principalOfDependantId">{{ dependant.principalOfDependant }}</option>
                            </select>
                        </template>
                    </tail-select>
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'principalOfDependantId').length">
                        {{ errors.filter(error => error.field == 'principalOfDependantId')[0].message }}</p>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-member-no" class="label-control">Member No:</label>
                    <input type="text" v-model.trim="patientInsurance.memberNo" id="grid-member-no" class="input-sm input-control text-xs">
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'memberNo').length">
                        {{ errors.filter(error => error.field == 'memberNo')[0].message }}</p>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-confirm-member-no" class="label-control">Confirm Member No:</label>
                    <input type="text" v-model.trim="patientInsurance.confirmMemberNo" id="grid-confirm-member-no" class="input-sm input-control text-xs">
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'confirmMemberNo').length">
                        {{ errors.filter(error => error.field == 'confirmMemberNo')[0].message }}</p>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-id-no" class="label-control">ID No:</label>
                    <input type="text" v-model.trim="patientInsurance.memberIDNo" id="grid-id-no" class="input-sm input-control text-xs">
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'memberIDNo').length">
                        {{ errors.filter(error => error.field == 'memberIDNo')[0].message }}</p>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-confirm-id-no" class="label-control">Confirm ID No:</label>
                    <input type="text" v-model.trim="patientInsurance.confirmMemberIDNo" id="grid-confirm-id-no" class="input-sm input-control text-xs">
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'confirmMemberIDNo').length">
                        {{ errors.filter(error => error.field == 'confirmMemberIDNo')[0].message }}</p>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-employer-2" class="label-control">Employer:</label>
                    <input type="text" v-model.trim="patientInsurance.employer" id="grid-employer-2" class="input-sm input-control text-xs">
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny pt-3">
                    <label for="grid-active" class="label-control mt-4">Active <input type="checkbox" v-model="patientInsurance.active" id="grid-active"></label>
                </div>
                <div class="w-full border-b-2 border-indigo-300 py-1">
                <h5 class="font-bold text-sm">Patient Insurance Details:</h5>
            </div>
            <div class="flex-1 flex flex-wrap">
                <div class="md:w-1/3 sm:w-full p-tiny">
                    <label for="grid-patient-name" class="label-control">Name:</label>
                    <input type="text" v-model.trim="patientInsurance.patientName" id="grid-patient-name" class="input-control input-sm text-xs">
                </div>
                <div class="md:w-1/3 sm:w-full p-tiny">
                    <label for="grid-patient-id-number" class="label-control">ID No:</label>
                    <input type="text" v-model.trim="patientInsurance.patientIDNO" id="grid-patient-id-number" class="input-control input-sm text-xs">
                </div>
                <div class="md:w-1/3 sm:w-full p-tiny">
                    <label for="grid-patient-member-number" class="label-control">Dependant No:</label>
                    <input type="text" v-model.trim="patientInsurance.dependantNO" id="grid-patient-member-number" class="input-control input-sm text-xs">
                </div>
            </div>
            <div class="w-full p-tiny text-right my-1 bg-gray-300">
                <button class="btn-sm text-white btn-danger rounded text-xs mr-8" @click.prevent="addInsurance=false"><i class="fa fa-times"></i> Close</button>
                <button class="btn-sm text-white bg-blue-500 whitespace-no-wrap rounded text-xs" @click.prevent="saveData"><i class="fa fa-save"></i> Insurance</button>
            </div>
        </div>
        </div>
        <div class="w-full p-tiny -m-1">
            <h5 class="font-bold text-left text-sm">Registered Insurances:</h5>
        </div>
        <div class="w-full overflow-auto mt-1">
            <table class="table table-hover">
                <thead class="bg-blue-500 text-sm text-white whitespace-no-wrap">
                    <tr class="flex w-full">
                        <th class="w-1/4 p-tiny">Insurance</th>
                        <th class="w-1/4 p-tiny">Principal Info</th>
                        <th class="w-1/4 p-tiny">Dependant Info</th>
                        <th class="w-1/5 p-tiny">Active</th>
                        <th class="w-1/5 p-tiny">Action</th>
                    </tr>
                </thead>
                <tbody class="text-xs font-semibold bg-gray-100 flex flex-col overflow-auto w-full h-32">
                    <tr class="flex content-start w-full" v-for="(patientIns, idx) in patientInsurances" :key="idx">
                        <td class="w-1/4 p-tiny">{{ patientIns.organization }}</td>
                        <td class="w-1/4 p-tiny">
                            <h5 class="font-bold text-sm">Member No: {{ patientIns.memberno }}</h5>
                            <h5 class="font-bold text-xs">ID NO: {{ patientIns.memberIDNo }}</h5>
                            <h5 class="font-bold text-xs">Employer: {{ patientIns.employer }}</h5>
                            <h5 class="font-bold text-xs">Dependant: {{ patientIns.principalOfDependant }}</h5>
                        </td>
                        <td class="w-1/4 p-tiny">
                            <h5 class="font-bold text-sm">Name: {{ patientIns.patientName }}</h5>
                            <h5 class="font-semibold text-xs">ID No: {{ patientIns.patientIDNo }}</h5>
                            <h5 class="font-semibold text-xs">Dependant No: {{ patientIns.dependantNo }}</h5>
                        </td>
                        <td class="w-1/6 p-tiny">{{ patientIns.active ? `Active` : `Inactive` }}</td>
                        <td class="w-1/5 p-tiny">
                            <button class="btn-sm btn-primary text-xs rounded md:mr-1 sm:my-1" 
                                @click.prevent=" () => { 
                                        patientInsurance = patientIns; addInsurance = true; errors = []; 
                                    }" title="Edit">
                                    <i class="fa fa-edit"></i> Edit</button>
                            <button class="btn-sm btn-info text-xs rounded" 
                                v-if="patientIns.active"
                                @click.prevent="selectInsuranceForUse(patientIns)" 
                                title="Select for use">
                                    <i class="fa fa-check-double"></i> Select For Use</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="w-full p-tiny -m-1">
            <h5 class="font-bold text-left text-sm">Selected For Use:</h5>
        </div>
        <div class="w-full overflow-auto mt-1">
            <table class="table table-hover">
                <thead class="bg-blue-500 text-sm text-white whitespace-no-wrap">
                    <tr class="flex w-full">
                        <th class="w-1/4 p-tiny">Insurance</th>
                        <th class="w-1/4 p-tiny">Principal Info</th>
                        <th class="w-1/4 p-tiny">Dependant Info</th>
                        <th class="w-1/5 p-tiny">Active</th>
                        <th class="w-1/5 p-tiny">Rebate</th>
                        <th class="w-1/5 p-tiny">Action</th>
                    </tr>
                </thead>
                <tbody  class="text-xs font-semibold bg-gray-100 flex flex-col overflow-auto w-full h-32">
                    <tr class="flex w-full" v-for="(patientInsuranceForUse, idx) in patientInsurancesForUse" :key="idx">
                        <td class="w-1/4 p-tiny">{{ patientInsuranceForUse.organization }}</td>
                        <td class="w-1/4 p-tiny">
                            <h5 class="font-bold text-sm">Member No: {{ patientInsuranceForUse.memberno }}</h5>
                            <h5 class="font-bold text-xs">ID NO: {{ patientInsuranceForUse.memberIDNo }}</h5>
                            <h5 class="font-bold text-xs">Employer: {{ patientInsuranceForUse.employer }}</h5>
                            <h5 class="font-bold text-xs">Dependant: {{ patientInsuranceForUse.principalOfDependant }}</h5>
                        </td>
                        <td class="w-1/4 p-tiny">
                            <h5 class="font-bold text-sm">Name: {{ patientInsuranceForUse.patientName }}</h5>
                            <h5 class="font-semibold text-xs">ID No: {{ patientInsuranceForUse.patientIDNo }}</h5>
                            <h5 class="font-semibold text-xs">Dependant No: {{ patientInsuranceForUse.dependantNo }}</h5>
                        </td>
                        <td class="w-1/6 p-tiny">{{ patientInsuranceForUse.active ? `Y` : `N` }}</td>
                        <td class="w-1/6 p-tiny">{{ patientInsuranceForUse.rebate }}</td>
                        <td class="w-1/5 p-tiny">
                            <button 
                                @click.prevent="deselectInsuranceForUse(patientInsuranceForUse)" 
                                class="btn-sm btn-danger text-xs rounded" title="Remove Insurance">
                                    <i class="fa fa-trash"></i> Remove</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
        <button 
            class="btn-sm bg-green-400 text-xs text-white whitespace-no-wrap rounded md:mr-8 sm:mr-1" 
            @click.prevent="$emit(`leaveForCash`)">
                <i class="fa fa-dollar-sign"></i> Leave for cash</button>
        <button 
            class="btn-danger btn-sm text-xs rounded" 
            @click="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
  </template>
</tail-modal>
</template>